import { createAdminBondPreviews } from "./AdminBondPreviews";

export const AdminBondPreviewsOpen = createAdminBondPreviews(
	"admin_bonds_open",
	(bond) => bond.status === "open",
);
